import React, { useCallback, useContext } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Link } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { FormattedMessage } from 'react-intl';
import { EntryPageTemplate } from 'gw-components-platform-react';
import { useAuthentication } from 'gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import metadata from './AccessDenied.metadata.json5';
import messages from './AccessDenied.messages';
import styles from './AccessDenied.module.scss';

const { applicationDetails } = appConfig;

function AccessDeniedPage() {
    const auth = useAuthentication();
    const translator = useContext(TranslatorContext);

    const doLogout = useCallback((event) => {
        event.preventDefault();
        auth.tdicLogout();
    }, [auth]);

    const onLogoutLink = useCallback(() => {
        return (
            <div>
                <FormattedMessage
                    {...messages.accessDeniedLink}
                    values={{
                        signIn: (
                            <Link onClick={(event) => doLogout(event)} href="/" className={styles.signInLink}>
                                {
                                    translator(messages.signIn)
                                }
                            </Link>
                        )
                    }}
                />
            </div>
        );
    // Execute only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrides = {
        logoutLink: {
            content: onLogoutLink()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent, overrides, resolvers
    );

    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
            isWideContent
        />
    );
}

export default AccessDeniedPage;
